module.exports = __webpack_public_path__ + "img/Avatar-80.1a219e65.svg";